export type FaqItem = {
  question: string;
  answer: string;
};

export const faqItems: FaqItem[] = [
  {
    question: "What is Pi?",
    answer:
      "Pi is Physics Wallah's academic OTT platform. It gives you self-paced access to every recorded lecture, DPP, note, PYQ series and AI doubt-solving across PW — for every major exam — in one subscription.",
  },
  {
    question: "What's included in Pi Pro?",
    answer:
      "Every recorded lecture from PW's top educators, unlimited DPPs and tests, handwritten notes, one-shot revision series, PYQ series, and unlimited AI doubt-solving. Across JEE, NEET, UPSC, GATE, Defence, CA, CUET, school boards (Class 1–12), and skill courses.",
  },
  {
    question: "Web or app?",
    answer:
      "Both. One subscription works across pw.live (web) and the PW app on Android & iOS. Start on web, continue on phone.",
  },
  {
    question: "Can I cancel anytime?",
    answer: "Yes. Cancel from your account settings whenever you want. No questions asked.",
  },
  {
    question: "Which exams does Pi cover?",
    answer:
      "JEE, NEET, UPSC, GATE, Defence, CA, CUET, CSIR NET, Olympiad, Class 1–12 boards, and skill courses. If PW teaches it, Pi has it.",
  },
  {
    question: "How is it different from free content on YouTube?",
    answer:
      "Pi is structured, complete and distraction-free. You get every chapter, organised by exam and subject — plus DPPs, notes, tests, and AI doubt-solving that YouTube can't give you.",
  },
];
